import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation/Navigation';
import Hero from '../components/Hero/Hero';
import About from '../components/About/About';
import Management from '../components/Management/Management';
import Schedule from '../components/Schedule/Schedule';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';
import Coaches from '../components/Coaches/Coaches';
import FAQ from '../components/FAQ/FAQ';
import Burn from '../components/Burn/Burn';
import Donate from '../components/Donate/Donate';
import { translations } from '../translations/translations';

const Home = () => {
    const [language, setLanguage] = useState('de');
    const t = translations[language];

    const scrollToSection = (section) => {
        const element = document.getElementById(section);
        if (element) {
            const navHeight = 80; // Approximate height of our nav
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - navHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        const hash = window.location.hash.replace('#', '');
        if (hash) {
            requestAnimationFrame(() => scrollToSection(hash));
        } else {
            window.scrollTo(0, 0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="bg-white min-h-screen selection:bg-primary selection:text-black">
            <Navigation
                language={language}
                setLanguage={setLanguage}
                t={t}
                scrollToSection={scrollToSection}
            />
            <main>
                <Hero t={t} scrollToSection={scrollToSection} />
                <About t={t} />
                <Management t={t} />
                <Coaches t={t} />
                <Schedule t={t} />
                <FAQ t={t} />
                <Burn t={t} />
                <Donate t={t} />
                <Contact t={t} />
            </main>
            <Footer t={t} />
        </div>
    );
};

export default Home;
